import type { BusinessCapability } from './businessProfile';

export const OPERATION_MODE_CAPABILITY_KEYS = [
  'inventory',
  'cash_sessions',
  'customer_credit_fiado',
  'promotions',
  'price_lists',
  'customer_loyalty',
  'expenses',
  'kitchen_tickets',
  'tables',
  'appointments',
  'purchases',
  'work_orders',
  // #900 Phase 3: optional capability toggles
  'delivery_fulfillment',
  'barcode_scan',
  'product_variants',
  'weight_uom',
  'commissions',
  'misc_quick_sale',
  'external_services',
  'menu_modifiers',
  'service_catalog',
  'service_quotes',
  'service_packages',
  'split_bill',
  'pos_tips',
  'on_duty',
] as const;

export const OPERATION_MODE_KEYS = [...OPERATION_MODE_CAPABILITY_KEYS, 'storefront'] as const;

export type OperationModeCapabilityKey = (typeof OPERATION_MODE_CAPABILITY_KEYS)[number];
export type OperationModeKey = (typeof OPERATION_MODE_KEYS)[number];
export type OperationModeMap = Partial<Record<OperationModeKey, boolean>>;

const ALLOWED = new Set<string>(OPERATION_MODE_KEYS);

export function parseOperationMode(businessConfig: Record<string, unknown> | null | undefined): OperationModeMap {
  const raw = businessConfig?.operation_mode;
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const out: OperationModeMap = {};
  for (const [key, value] of Object.entries(raw as Record<string, unknown>)) {
    if (!ALLOWED.has(key) || typeof value !== 'boolean') continue;
    out[key as OperationModeKey] = value;
  }
  return out;
}

export function isOperationModeCapabilityOff(
  mode: OperationModeMap,
  capability: BusinessCapability,
): boolean {
  if (!(OPERATION_MODE_CAPABILITY_KEYS as readonly string[]).includes(capability)) return false;
  return mode[capability as OperationModeCapabilityKey] === false;
}

export function isOperationModeStorefrontOff(mode: OperationModeMap): boolean {
  return mode.storefront === false;
}
